import { Contact } from '../contact';
export class Salesunit {
    constructor(
        public id?: number,
        public name?: string,
        public salesunitNumber?: number,
        public boothType?: string,
        public boothWidth?: number,
        public boothDepth?: number,
        public boothSize?: number,
        public energyType?: string,
        public identification?: string,
        public assortment?: string,
        public assortmentAdditional?: string,
        public assortmentExtended?: string,
        public assortmentExtendedAdditional?: string,
        public contactFirstname?: string,
        public contactLastname?: string,
        public contactMobile?: string,
        public boothWidthWinter?: number,
        public boothDepthWinter?: number,
        public boothSizeWinter?: number,
        public energyTypeWinter?: string,
        public winterStart?: any,
        public winterEnd?: any,
        public merchantNumber?: string,
        public merchantGguid?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public merchant?: Contact,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit.model.ts